import { render } from "./OldSchoolHeader.vue?vue&type=template&id=c3d298a6&scoped=true"
import script from "./OldSchoolHeader.vue?vue&type=script&lang=js"
export * from "./OldSchoolHeader.vue?vue&type=script&lang=js"

import "./OldSchoolHeader.vue?vue&type=style&index=0&id=c3d298a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d298a6"]])

export default __exports__